import { render, staticRenderFns } from "./PromotionPlan.vue?vue&type=template&id=d61fa2a6&scoped=true"
import script from "./js/promotionPlan.js?vue&type=script&lang=js&external"
export * from "./js/promotionPlan.js?vue&type=script&lang=js&external"
import style0 from "./PromotionPlan.vue?vue&type=style&index=0&id=d61fa2a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61fa2a6",
  null
  
)

export default component.exports